import HttpService from "./http.service";

class TerritoryService extends HttpService {

    list = (params) => this.get("territory/list", params);

    licensedTerritoriesList = (params) => this.get("territory/licensed_list", params);

    store = (params) => this.post("territory/store", params);

    deleteTerritory = (params) => this.delete(`territory/licensed/${params}`,);

}

export default new TerritoryService();
